'use client';

import { startTransition, useEffect, useMemo, useState } from 'react';
import { findScrollContainer } from './find-scroll-container';
import { useScrolling } from './use-scrolling';
export const useIsStuck = (target: HTMLElement | null, minScroll = 0) => {
  const [isStuck, setStuck] = useState<boolean>(false);
  const parent = useMemo(() => target ? findScrollContainer(target) : null, [target]);
  const isScrolling = useScrolling(parent, minScroll);
  useEffect(() => {
    startTransition(() => {
      if (!target || !window || !parent) {
        return;
      }
      if (!isScrolling) {
        setStuck(false);
        return;
      }
      const stickyElementStyle = window.getComputedStyle(target);
      const stickyElementTop = Number.parseInt(stickyElementStyle.top, 10);
      const currentTop = target.getBoundingClientRect().top;
      setStuck(currentTop <= stickyElementTop);
    });
  }, [target, isScrolling]);
  return isStuck;
};